// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + ".chunk." + {"2284":"e9e69","4433":"dab35"}[chunkId] + ".css";
};